var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgCircle5 = function SvgCircle5(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em",
    fill: "none",
    viewBox: "0 0 188 59"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    stroke: "#5F2DD3",
    strokeLinecap: "round",
    strokeWidth: 3,
    d: "M60.284 2C30.231 2-1.082 8.64 6.25 31.592c6.071 19.006 53.066 26.171 89.551 25.344 37.526-.85 106.931-6.108 86.516-37.429-4.132-6.339-13.054-9.808-28.232-13.031-31.267-6.64-86.29-3.966-133.568 2.113C8.375 10.15 2 15.28 2 15.28"
  })));
};
export default SvgCircle5;